module.exports = __webpack_public_path__ + "static/media/MariaTidwell.e1557091.png";